export function mapRxDbFieldName(fieldName) {
    switch (fieldName) {
        case 'deleted':
            return '__rxdb_deleted';
        case 'synced':
            return '__rxdb_synced';
        default:
            return fieldName;
    }
}
export function unmapRxDbFieldName(fieldName) {
    switch (fieldName) {
        case '__rxdb_deleted':
            return 'deleted';
        case '__rxdb_synced':
            return 'synced';
        default:
            return fieldName;
    }
}
export function mapRxDbPrimaryKey(primaryKey) {
    if (typeof primaryKey === 'string') {
        return mapRxDbFieldName(primaryKey);
    }
    return {
        key: mapRxDbFieldName(primaryKey.key),
        fields: primaryKey.fields.map((fieldName) => mapRxDbFieldName(fieldName)),
        separator: primaryKey.separator
    };
}
export function toRxDbDocument(document) {
    return Object.fromEntries(Object.entries(document).map(([fieldName, value]) => [mapRxDbFieldName(fieldName), value]));
}
export function fromRxDbDocument(document) {
    return Object.fromEntries(Object.entries(document).map(([fieldName, value]) => [unmapRxDbFieldName(fieldName), value]));
}
